module.exports = __webpack_public_path__ + "static/media/P360_Logo.a4af50e8.svg";